import { Button } from "components/atoms/button/button";
import { NpsCocoImage } from "../nps-coco-image/nps-coco-image";
import { Rating } from "../rating/rating";
import {
  RatingFormContainer,
  RatingFormHeading,
  SkipCTA,
  StyledButtonContainer
} from "./nps-rating-form.styles";
import { IUseNpsRatingFormProps } from "./nps-rating-form.types";
import { useNpsFormRating } from "./useNpsRatingForm";

const NpsRatingForm = ({
  submitNpsFeedback,
  onClose,
  handleScaleChange
}: IUseNpsRatingFormProps): JSX.Element => {
  const { scale, setScale, label, handleSubmit, handleClickSkip } =
    useNpsFormRating({ submitNpsFeedback, onClose, handleScaleChange });
  return (
    <RatingFormContainer>
      <RatingFormHeading>
        Seberapa ingin kamu merekomendasikan CoLearn ke teman atau keluargamu?
      </RatingFormHeading>
      <NpsCocoImage rating={scale} />
      <Rating scale={scale} setScale={setScale} label={label} />
      <StyledButtonContainer>
        <Button
          onClick={() => handleSubmit()}
          disabled={scale === "" || scale === null}
          isFullWidth={true}
          variant="primary">
          Kirim
        </Button>
      </StyledButtonContainer>
      <SkipCTA onClick={() => handleClickSkip()}>Lewati</SkipCTA>
    </RatingFormContainer>
  );
};

export { NpsRatingForm };
